<template>
  <div>
    <div v-if="tourSettings && tourSettings.languages && tourSettings.languages.length > 1">
      <div class="relative overflow-x-auto hide-scrollbar">
        <div
          :class="`flex my-4 ${tourSettings.languages.length === 2 || tourSettings.languages.length < 3 ? 'justify-center' : ''}`"
          :style="{
            width: tourSettings.languages.length >= 3 ? 'auto' : '100%',
          }"
        >
          <div 
            v-for="(item, index) in tourSettings.languages" 
            :key="index" 
            class="relative"
          >
            <!-- Check icon for active language -->
            <div 
              v-if="currentLanguage === item.code"
              :class="`absolute ${index + 1 === tourSettings.languages.length ? 'right-1' : 'right-5'} -top-2 w-5 h-5 p-0.5 rounded-full bg-white z-10`"
            >
              <CheckIcon class="w-4 h-4 text-black" />
            </div>
            
            <!-- Language button -->
            <div 
              :class="`relative ${tourSettings.languages.length > 3 ? 'w-[20vw]' : 'w-[calc(33.333vw-2rem)]'} ${index !== tourSettings.languages.length - 1 ? 'mr-4' : ''}`"
              @click="switchLanguage(item.code)"
              class="cursor-pointer select-none focus:outline-none touch-manipulation"
              tabindex="0"
            >
              <!-- Background circle -->
              <div
                :class="`absolute w-full h-12 border rounded-full ${(currentLanguage === item.code) ? 'opacity-100' : 'opacity-30'}`"
                :style="{
                  backgroundColor: `${currentLanguage === item.code ? hexToRGB('#ffffff', 0.1) : ''}`,
                  borderColor: `${borderColor ? borderColor : '#000000'}`
                }"
              >
              </div>
              
              <!-- Flag and content -->
              <div class="w-full h-8 py-1 text-center items-center">
                <div class="text-sm my-1 mx-auto rounded-full border border-white h-8 w-8 overflow-hidden relative">
                  <div class="absolute w-12 h-8 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-blue-500 select-none">
                    <div v-html="getCountryFlagByLanguage(item.code)" class="select-none pointer-events-none"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CheckIcon } from '@heroicons/vue/16/solid'
import { getCountryFlagByLanguage, hexToRGB } from '../utils/languageUtils'

export default {
  name: 'LanguageSwitcher',
  components: {
    CheckIcon
  },
  props: {
    borderColor: {
      type: String,
      default: '#000000'
    }
  },
  computed: {
    ...mapGetters('settings', ['tourSettings']),
    currentLanguage() {
      // Prefer ?lang query, then store, then i18n, then URL path
      const queryLanguage = this.$route?.query?.lang
      const i18nLanguage = this.$i18n?.locale
      
      console.log('LanguageSwitcher currentLanguage check:', {
        queryLanguage,
        i18nLanguage
      })
      
      return queryLanguage || i18nLanguage || 'en'
    }
  },
  methods: {
    async switchLanguage(languageCode) {
      console.log('=== LANGUAGE SWITCHER ===')
      console.log('Switching to language:', languageCode)
      console.log('Current i18n locale before:', this.$i18n.locale)
      
      // Update i18n directly
      this.$i18n.locale = languageCode
      
      console.log('Current i18n locale after:', this.$i18n.locale)
      console.log('localStorage value:', localStorage.getItem('vue-selected-language'))
      console.log('=== END LANGUAGE SWITCHER ===')
      
      // Update URL to reflect language change without page reload
      this.updateUrlLanguage(languageCode)
    },
    
    updateUrlLanguage(languageCode) {
      // Use Vue Router replace so $route updates reactively and components re-compute
      const route = this.$route
      const newQuery = { ...(route.query || {}), lang: languageCode }
      if (route.name) {
        this.$router.replace({ name: route.name, params: route.params, query: newQuery })
      } else {
        this.$router.replace({ path: route.path, query: newQuery })
      }

      // Dispatch a custom event to notify other components about the language change
      window.dispatchEvent(new CustomEvent('languageChanged', { 
        detail: { language: languageCode, path: window.location.href } 
      }))
    },

    getCountryFlagByLanguage,
    hexToRGB
  }
}
</script>

<style scoped>
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Additional CSS to prevent selection and focus styling */
:deep(svg) {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  pointer-events: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
}

:deep(svg * ) {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  pointer-events: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
}

/* Mobile-specific touch handling */
@media (max-width: 768px) {
  :deep(svg) {
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-action: manipulation;
    touch-action: manipulation;
  }
  
  :deep(svg *) {
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-action: manipulation;
    touch-action: manipulation;
  }
}

/* Prevent iOS Safari selection */
* {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
}

/* Prevent Android Chrome selection */
* {
  -webkit-touch-action: manipulation;
  touch-action: manipulation;
}
</style> 